// Selección múltiple de bodegas activas mediante casillas.
// Se usa dos veces en Traslados por Saldo: las que envían y las que reciben.
// Ambas instancias son independientes: una bodega puede estar en las dos.
import React, { useState, useEffect } from "react";
import { Building2 } from "lucide-react";
import { COLORS, apiFetch, labelStyle, btnSmallInfo } from "./ui";

function BodegaMultiSelect({ token, label, seleccion, onChange }) {
  const [bodegas, setBodegas] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    apiFetch("/bodegas?activo=true", {}, token)
      .then(res => setBodegas(Array.isArray(res) ? res : []))
      .catch(() => setBodegas([]))
      .finally(() => setCargando(false));
  }, [token]);

  const toggle = (id) => {
    onChange(seleccion.includes(id)
      ? seleccion.filter(b => b !== id)
      : [...seleccion, id]);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6, minWidth: 220 }}>
      <label style={{ ...labelStyle, marginBottom: 2 }}>
        <Building2 size={12} style={{ marginRight: 4 }} />{label}
        {seleccion.length > 0 && (
          <span style={{ color: COLORS.primary, marginLeft: 6 }}>
            ({seleccion.length})
          </span>
        )}
      </label>

      {cargando ? (
        <span style={{ fontSize: 12, color: COLORS.textDim }}>Cargando bodegas…</span>
      ) : bodegas.length === 0 ? (
        <span style={{ fontSize: 12, color: COLORS.textDim }}>No hay bodegas activas</span>
      ) : (
        <>
          <div style={{ display: "flex", gap: 6 }}>
            <button
              onClick={() => onChange(bodegas.map(b => b.id_bodega))}
              style={{ ...btnSmallInfo, padding: "2px 10px", fontSize: 11 }}
            >Todas</button>
            <button
              onClick={() => onChange([])}
              style={{ ...btnSmallInfo, padding: "2px 10px", fontSize: 11 }}
            >Ninguna</button>
          </div>
          <div style={{
            maxHeight: 180, overflowY: "auto", border: `1px solid ${COLORS.border}`,
            borderRadius: 8, padding: "6px 10px", background: COLORS.surface
          }}>
            {bodegas.map(b => (
              <label key={b.id_bodega} style={{
                display: "flex", alignItems: "center", gap: 8,
                padding: "3px 0", fontSize: 12, color: COLORS.textSecond, cursor: "pointer"
              }}>
                <input
                  type="checkbox"
                  checked={seleccion.includes(b.id_bodega)}
                  onChange={() => toggle(b.id_bodega)}
                />
                <span style={{ fontWeight: 600 }}>{b.id_bodega}</span>
                <span style={{ color: COLORS.textDim }}>{b.descripcion}</span>
              </label>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default BodegaMultiSelect;
